import { useEffect, useState } from 'react';
import type { ModalProps } from 'antd';
import type { GlobalToken } from 'antd/es/theme/interface';

const FULLSCREEN_MEDIA_QUERY = '(max-width: 899px)';

export const useIsFullScreenModal = () => {
    const [isFullScreen, setIsFullScreen] = useState(
        () => window.matchMedia(FULLSCREEN_MEDIA_QUERY).matches,
    );

    useEffect(() => {
        const mediaQuery = window.matchMedia(FULLSCREEN_MEDIA_QUERY);
        const handleChange = (event: MediaQueryListEvent) =>
            setIsFullScreen(event.matches);

        mediaQuery.addEventListener('change', handleChange);
        return () => mediaQuery.removeEventListener('change', handleChange);
    }, []);

    return isFullScreen;
};

export const getQuickAdjustModalLayout = (
    isFullScreen: boolean,
    token: GlobalToken,
): Pick<ModalProps, 'width' | 'centered' | 'style' | 'styles'> => ({
    width: isFullScreen ? '100vw' : 720,
    centered: !isFullScreen,
    style: {
        height: isFullScreen ? '100vh' : 813,
        ...(isFullScreen ? { top: 0, maxWidth: '100vw', margin: 0 } : {}),
    },
    styles: {
        container: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            borderRadius: isFullScreen ? 0 : undefined,
            padding: 0,
        },
        header: {
            flexShrink: 0,
            margin: 0,
            padding: '18px 20px',
            borderBottom: `1px solid ${token.colorBorderSecondary}`,
        },
        body: {
            flex: '1 1 auto',
            minHeight: 0,
            overflowY: 'auto',
            padding: '18px 20px',
        },
        footer: {
            flexShrink: 0,
            background: token.colorBgElevated,
            borderTop: `1px solid ${token.colorBorderSecondary}`,
            padding: '14px 20px',
        },
    },
});
